/* @flow */
import CurrentUser from 'auth/CurrentUser';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

// Returns an onEnter function that will require that a user can be a group owner.
const RequireOwnerOnEnter = (
  nextState: RouterState,
  replaceWith: (location: LocationDescriptor) => void
) => {
  const user = CurrentUser.isSignedIn() ? CurrentUser.getUser() : null;
  if (!(user && user.canOwnGroups())) {
    replaceWith('/error');
  }
};

export default RequireOwnerOnEnter;
